export const HOME_PHONE_TYPE_ID = 1;
export const WORK_PHONE_TYPE_ID = 2;
export const CELL_PHONE_TYPE_ID = 3;
